import React, {useEffect} from "react";
import logsImage from "../../Assets/Images/User Icon FT.svg";
import { Row } from "react-bootstrap";
import editIcon from "../../Assets/Images/edit icon.svg";
import { useState } from "react";
import EditHealthMessage from "../Modals/EditHealthMessage";
import messages from "../../Assets/Images/messages.png";
import { DeleteHealthMessagesApi, ViewHealthMessagesApi } from "../../Utils/API/ApiCall";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import sortUp from "../../Assets/Images/sortup.png";
import sortDown from "../../Assets/Images/sortdown.png";
import Pagination from "../Pagination/Pagination";
import deleteIcon from "../../Assets/Images/delete icon.png";
import { Modals } from "../Modals/Modals";
import EditModal from "../Modals/EditHealthMessage";

const HealthMessageTable = ({SearchValue}) => {
  const [modalShow, setModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [indexer, setIndexer] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [healthMessageDatalist, setHealthMessageDatalist] = useState([]);
  const [limit, setLimit] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [editIndexer, setEditIndexer] = useState();
  const [sortClick, setSortClick] = useState(1);
  const [loading, setLoading] = useState(false);
  const [healthMessage, setHealthMessage] = useState(""); 

  useEffect(() => {
    if (isDelete == true) {
      handleDelete(indexer);
      setModalShow(false);
      setIsDelete(false);
    }
  }, [isDelete]);

  useEffect(() => {
    setLoading(true);
    HealthMessageListdata();
  }, [pageNumber, sortClick, SearchValue]);


  const HealthMessageListdata = async () => {
    const data = {
      limit: 10,
      current_page: SearchValue ? 0 : pageNumber,
      sort_type: sortClick,
      column_name: "created_at",
      search_value: SearchValue,
    };
    const Response = await ViewHealthMessagesApi(data);
    setLoading(false);
    setHealthMessageDatalist(Response.data.health_messages);
    setLimit(Response.data.limit);
    setTotalPageCount(Response.data.total_rows);
  };

  const handleDelete = async () => {
    const data = {
      health_msg_id: indexer,
    };
    const Response = await DeleteHealthMessagesApi(data);
    if (Response.status === 200) {
      toast.success(Response.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  const handleHealthMessage = async (payload) => {
    const data = {
      health_msg_id: payload,
    };
    // const Response = await EditPlaceholderBreedApi(data)
  };
  const handleClickEdit = (data) => {
    console.log("data", data);
    setEditModalShow(true);
    handleHealthMessage(data.health_msg_id);
    setEditIndexer(data);
  };

  const handleEditHide = () => {
    setEditModalShow(false);
    window.location.reload();
  };

  return (
    <>
   {loading ? <Loader /> : ""}
      <div className="TableMain">
        <table>
          <thead>
            <tr>
              <th className="tablehead">
                <div className="tableheaders position-relative">
                  Health Messages
                  <div className="SortButton">
                    <img
                      src={sortUp}
                      onClick={() => {
                        setSortClick(2);
                      }}
                    />
                    <img
                      src={sortDown}
                      onClick={() => {
                        setSortClick(1);
                      }}
                    />
                  </div>
                </div>
              </th>
              <th className="tablehead">
                <div className="tableheaders">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody id="TBody">
            {healthMessageDatalist?.length > 0 ? (
              healthMessageDatalist.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.health_message}</td>
                    <td>
                      <div className="table-action">
                      <img
                          loading="lazy"
                          title="Edit"
                          src={editIcon}
                          onClick={() => {
                            handleClickEdit(item);
                          }}
                        />
                        <img
                          loading="lazy"
                          title="Delete"
                          src={deleteIcon}
                          onClick={() => {
                            setModalShow(true);
                            setIndexer(item.health_msg_id);
                            // setBreedName(item.breed_name);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <td className="NoDataAvailable" colSpan={2}>
                <p className="NoDataAvailable">No data available!</p>
              </td>
            )}
          </tbody>
        </table>
      </div>
      {totalPageCount > 10 ? (
        <>
          <Pagination
            Limit={limit}
            SetPageNumber={setPageNumber}
            TotalPageCount={totalPageCount}
          />
        </>
      ) : (
        <></>
      )}
      <Modals
        show={modalShow}
        onHide={() => setModalShow(false)}
        setIsDelete={setIsDelete}
        head={"Are you sure you want to delete?"}
      />
      <EditModal
        show={editModalShow}
        onHide={handleEditHide}
        head="Edit the health message"
        detail="You can edit the health message here"
        // placeholder={breedPlaceholder}
        value={editIndexer}
        editIndexer={editIndexer}
      />
    </>
  );
};

export default HealthMessageTable;
